// Module
var code = "<div class=\"debugger-floater\" style=\"display:flex;padding:16px\"> <div class=\"start-stop-recording\"> Start Logging </div> &nbsp; &nbsp; <div id=\"spark-line-throughput\" style=\"float:right;width:225px;height:40px\"></div> </div> ";
// Exports
export default code;